export const targetArea = {
  Document: -2,
  Client: -1,
  Asset: -5
};
